import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class ConnexionInformationsValidatorService {
	validateUsername(username: string): string | null {
		const usernamePattern = /^(?!.*[._-]{2})[a-zA-Z0-9._-]{3,15}$/;
		const forbiddenWords = ['admin', 'support', 'moderator', 'root'];

		if (username.length < 3 || username.length > 15) {
			return 'The username must be between 3 and 15 characters long.';
		}

		if (!usernamePattern.test(username)) {
			return 'The username can contain only letters, numbers, points, dashes and underscores.';
		}

		if (/^[._-]|[._-]$/.test(username)) {
			return 'The username must not begin or end with a period, dash or underscore.';
		}

		for (const word of forbiddenWords) {
			if (username.toLowerCase().includes(word)) {
				return `The username cannot contain forbidden words like '${word}'.`;
			}
		}

		return null;
	}
	validateEmail(email: string): string | null {
		const forbiddenWords = ['test', 'admin', 'noreply'];

		const emailParts = email.split('@');
		if (emailParts.length !== 2) {
			return 'The email must contain a single "@" character.';
		}

		const [userNamePart, domainPart] = emailParts;

		//  Verifier la premiere partie avant @
		const localPartPattern = /^[a-zA-Z0-9][a-zA-Z0-9._-]{1,64}$/;
		if (!localPartPattern.test(userNamePart)) {
			return 'The part before "@" can contains only letters, numbers, points, dashes and underscores.';
		}
		// Verifier la deuxieme partie (domaine)
		const domainParts = domainPart.split('.');
		if (domainParts.length < 2) {
			return 'The domain must contain a "." character.';
		}

		const domainName = domainParts.slice(0, -1).join('.');
		const topLevelDomain = domainParts[domainParts.length - 1];

		const domainPattern = /^[a-zA-Z0-9.-]{1,253}$/;
		const tldPattern = /^[a-zA-Z]{2,3}$/;

		if (!domainPattern.test(domainName)) {
			return 'The domain part contains invalid characters or is too long.';
		}

		if (!tldPattern.test(topLevelDomain)) {
			return 'The domain extension must contain only letters and be between 2 and 3 characters long.';
		}

		for (const word of forbiddenWords) {
			if (email.toLowerCase().includes(word)) {
				return `The email cannot contain forbidden words like '${word}'.`;
			}
		}

		return null;
	}

	validatePasswordComplexity(password: string): string | null {
		const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#_.-])[A-Za-z\d@$!%*?&#_.-]{8,}$/;

		if (!password) {
			return 'The password is required.';
		}

		if (!regex.test(password)) {
			return 'Password must be at least 8 characters with a capital letter, a lowercase letter, a number, and a special character(like !, @,#, or $).';
		}

		return null;
	}
}
